import exitimg from '../Images/ic_exit.png'

function ExitButton(props){

     
    return(
          <div onClick={props.closeFunc}><img className="exiticon" src={exitimg} alt="" ></img></div>
    )
}

export default ExitButton;